export const enum FormPropertyShareStatechartStateEnum {
  /**
   * Idle state
   */
  idle = 'idle',

  /**
   * Validating user input
   */
  validating = 'validating',

  /**
   * When form is valid but captcha haven't executed yet
   */
  submitting = 'submitting',

  /**
   * Captcha is executed and ready to send request to backend
   */
  submitted = 'submitted',

  /**
   * Request was sent and backend responded with success
   */
  sent = 'sent',
}
